import inventoryAdjustmentDetailApi from '../../../api/inventory/adjustment/inventoryAdjustmentDetailApi';

const InventoryAdjustmentDetailService = {
    /**
     * ➕ Agrega un producto al ajuste
     * POST /api/inventory/adjustments/details/{adjustmentId}
     */
    addDetail: async (adjustmentId: number, payload: any) => {
        const response = await inventoryAdjustmentDetailApi.addCustom(
            `/${adjustmentId}`,
            payload
        );
        return response.data;
    },

    /**
     * ✏️ Actualiza un producto del ajuste
     * PUT /api/inventory/adjustments/details/{detailId}
     */
    updateDetail: async (detailId: number, payload: any) => {
        const response = await inventoryAdjustmentDetailApi.modifyCustom(
            `/${detailId}`,
            payload
        );
        return response.data;
    },

    /**
     * ❌ Elimina un producto del ajuste
     * DELETE /api/inventory/adjustments/details/{detailId}
     */
    deleteDetail: async (detailId: number) => {
        const response = await inventoryAdjustmentDetailApi.removeCustom(
            `/${detailId}`
        );
        return response.data;
    },

    /**
     * 🔍 Lista los detalles de un ajuste
     * GET /api/inventory/adjustments/details/by-adjustment/{adjustmentId}
     */
    getByAdjustment: async (adjustmentId: number) => {
        const response = await inventoryAdjustmentDetailApi.fetchCustom(
            `/by-adjustment/${adjustmentId}`
        );
        return response.data;
    },


    /**
 * 🔍 Obtiene un detalle de ajuste por ID (para edición)
 * GET /api/inventory/adjustments/details/{detailId}
 */
    getById: async (detailId: number) => {
        const response = await inventoryAdjustmentDetailApi.fetchCustom(
            `/details/${detailId}`
        );
        return response.data;
    },

};

export default InventoryAdjustmentDetailService;
